import { DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/pl_PL";
import dayjs from "dayjs";

const RangePicker = ({ value, onChange }) => (
  <DatePicker.RangePicker
    locale={locale}
    inputReadOnly
    format="DD-MM-YYYY"
    value={value ? value.map((date) => dayjs(date)) : []}
    onChange={onChange}
    style={{
      width: "100%",
    }}
  />
);

export default RangePicker;
